import { create } from 'zustand';
import { User } from '../types';
import { authApi } from '../services/api';
import { getTelegramUser } from '../services/telegramService';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (user: User) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
  autoLogin: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  login: (user: User) => {
    set({ user, isAuthenticated: true, isLoading: false });
  },
  logout: () => {
    localStorage.removeItem('authToken');
    set({ user: null, isAuthenticated: false, isLoading: false });
  },
  updateUser: (user: Partial<User>) => 
    set((state) => ({ 
      user: state.user ? { ...state.user, ...user } : null 
    })),
  autoLogin: async () => {
    try {
      // Try to verify existing token first
      const token = localStorage.getItem('authToken');
      if (token) {
        try {
          const response = await authApi.verifyToken();
          if (response.success && response.user) {
            set({ 
              user: {
                id: response.user.id,
                telegramId: response.user.telegramId,
                username: response.user.username || '',
                firstName: response.user.firstName || '',
                lastName: response.user.lastName || '',
                email: response.user.email || '',
                balance: response.user.balance || 0,
                totalEarned: 0,
                pendingRebate: response.user.pendingRebate || 0,
                points: response.user.points || 0,
                createdAt: response.user.createdAt,
              },
              isAuthenticated: true,
              isLoading: false
            });
            return;
          }
        } catch (error) {
          // Token invalid, try to login with Telegram
          localStorage.removeItem('authToken');
        }
      }

      // Auto login with Telegram ID
      const telegramUser = getTelegramUser();
      if (telegramUser) {
        const response = await authApi.loginWithTelegram({
          telegramId: telegramUser.id,
          firstName: telegramUser.first_name || '',
          lastName: telegramUser.last_name || '',
          username: telegramUser.username || '',
        });

        if (response.success && response.user) {
          set({ 
            user: {
              id: response.user.id,
              telegramId: response.user.telegramId,
              username: response.user.username || '',
              firstName: response.user.firstName || '',
              lastName: response.user.lastName || '',
              email: response.user.email || '',
              balance: response.user.balance || 0,
              totalEarned: 0,
              pendingRebate: response.user.pendingRebate || 0,
              points: response.user.points || 0,
              createdAt: response.user.createdAt,
            },
            isAuthenticated: true,
            isLoading: false
          });
        } else {
          set({ isLoading: false });
        }
      } else {
        set({ isLoading: false });
      }
    } catch (error) {
      console.error('Auto login error:', error);
      set({ isLoading: false });
    }
  },
}));

